<div class="site-navigation" id="sidebar-menu">

  <div class="menu buttonEl" [ngClass]="{ hovereffect: this.multimodalService.config.modalities[1].active }" id="menu-icon" (click)="showNavigationMenu()"></div>

  <!-- desktop multimodal menu  -->
  <div class="screen-multimodal-menu">
    <app-multimodal></app-multimodal>
  </div>

  <div class="theme-toggle-switch">
    <div class="theme-state-icon {{ this.multimodalService.config.theme }}"></div>
    <label class="switch buttonEl">
      <input type="checkbox" class="buttonEl" id="toggleSwitch" (change)="updateTheme()">
      <span class="slider round buttonEl"></span>
    </label>
  </div>

</div>

<div class="open-site-navigation" id="full-screen-menu">
  <ul class="menu-items" id='open-menu'>
    <li class="buttonEl" *ngFor="let nav of this.contact_info?.navigation" [ngClass]="{ hovereffect: this.multimodalService.config.modalities[1].active }">
      <div class="nav-item" (click)="navigateTo(nav.hash)">
        <p class="fill-text-on-hover buttonEl" [attr.data-text]="nav.page">{{ nav.page }}</p>
      </div>
    </li>
  </ul>

  <!-- mobile multimodal menu  -->
  <div class="mobile-multimodal-menu">
    <app-multimodal></app-multimodal>
  </div>

  <div class="contact-details" id="menu-contact-details">
    <div class="email buttonEl">
      <p class="email-text buttonEl">Email</p>
      <span class="buttonEl email-text mail" (click)="linkTo('mailto:' + this.contact_info?.email)">{{ this.contact_info?.email }}<div class="buttonEl arrow-link"
        [ngClass]="{ hovereffect: this.multimodalService.config.modalities[1].active }"></div></span>
    </div>
    <ul class="social-media-list">
      <li class="buttonEl" *ngFor="let item of this.contact_info?.social_media" (click)="linkTo(item.url)" alt="visit my {{ item.name }} profile">
        {{ item.name }}
      </li>
    </ul>
  </div>
</div>
